import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-900 font-medium text-xl mb-2" }
const _hoisted_2 = { class: "text-600" }



interface Properties {
  label: string,
  text: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BsLabel',
  props: {
    label: null,
    text: null
  },
  setup(__props: any) {

const props = __props as {
  label: string,
  text: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.text), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
  ], 64))
}
}

})